export default class Accordions {
    constructor() {
      this.accordions()
    }
  
    private accordions() {
        let copyOpen = "accordion__copy--open";
        let titles = document.querySelectorAll(".js-title");

        titles.forEach(item => {
            item.addEventListener("click",toggleItem,false);
        });

        function toggleItem(e:any){
            let openCopy = document.querySelector("."+copyOpen);
            let sameElem = false;

            if (openCopy){
                closeItem(openCopy);
                sameElem = openCopy.previousElementSibling === e.target;
            }

            if (!sameElem){
                let panel = e.target.nextElementSibling;
                openItem(panel);
            }
        }

        function closeItem(openCopy:any){
          openCopy.classList.remove(copyOpen);
          openCopy.style.maxHeight = 0;
          openCopy.style.padding = "4rem 0 0 0";
          openCopy.parentNode.classList.remove('active');
        }

        function openItem(panel:any){
          panel.classList.add(copyOpen);
          panel.parentNode.classList.add('active');
          panel.style.maxHeight = 80 + panel.scrollHeight + "px";
          panel.style.padding = "4rem 0";
        }

        let defaultPanel = document.querySelector(".accordion__copy");

        if (defaultPanel){
          defaultPanel.classList.remove(copyOpen);
          setTimeout(openItem,1000,defaultPanel);
        }
    }
}
  

